import { Component, Input } from "@angular/core";
import { Funcion } from 'app/dto/funcion.dto';
import { Usuario } from "app/dto/usuario.dto";
import { StorageService } from "app/service/storage.service";

@Component({
  selector: 'masajear-roles',
  templateUrl: './masajear-roles.component.html',
  styleUrls: ['./masajear-roles.component.scss'],
})
export class MasajearRolesComponent {

  funcionsAAsociar: Funcion[] = [];
  @Input()
  funciones: Funcion[];
  user: Usuario;
  constructor(
    private storageService: StorageService,) {
    this.user = JSON.parse(this.storageService.getItem('user')) as Usuario;
  }

  ngOnInit() {
    if (this.user && this.user.funciones && this.user.funciones.length > 0) {
      this.funcionsAAsociar = this.user.funciones;
      for (const funcion of this.funciones) {
        const piezaEncontrada = this.funcionsAAsociar.filter(p => p.idFuncion === funcion.idFuncion);
        if (piezaEncontrada !== null && Array.isArray(piezaEncontrada) && piezaEncontrada.length > 0) {
          funcion.checked = true;
        }
      }
    }
  }


  agregarSacarFuncion(funcion: Funcion) {
    const funcionEncontrado = this.funcionsAAsociar.filter(p => p.idFuncion === funcion.idFuncion);
    if (funcionEncontrado !== null && Array.isArray(funcionEncontrado) && funcionEncontrado.length > 0) {
      funcion.checked = false;
      this.funcionsAAsociar.splice(this.funcionsAAsociar.indexOf(funcionEncontrado[0]), 1);
    } else {
      funcion.checked = true;
      this.funcionsAAsociar.push(funcion);
    }
  }

  cocinarFunciones() {
    this.user.funciones = this.funcionsAAsociar;

    this.storageService.setItem('user', JSON.stringify(this.user));
    window.location.reload();
  }

  limpiarFunciones() {
    this.funcionsAAsociar = [];
    for (const funcion of this.funciones) {
      funcion.checked = false;
    }
  }
}
